import React from 'react';
import { compose, withProps } from 'recompose';
import { Field, formValueSelector } from 'redux-form/immutable';
import { connect } from 'react-redux';

import { InputGroup } from '../../../../app/components/Form';
import { withCustomer } from '../../../../app/containers';
import { useTranslation } from 'react-i18next';

const MileageAllowence = compose(
  connect((state, { form, fieldName }) => ({
    customerId: formValueSelector(form)(state, `${fieldName}.customer`),
  })),
  withCustomer,
  withProps(({ customer }) => ({
    customerName: customer ? customer.get('name') : '',
  })),
)(({ fieldName, customerName }) => (
  <Field
    label={`${customerName}`}
    name={`${fieldName}.kilometers`}
    component={InputGroup}
    type="number"
    inputAddonAfter="km"
    testID="MileageAllowence"
  />
));

function MileageAllowences({ fields, form }) {
  const { t } = useTranslation();
  if (fields.length === 0) {
    return null;
  }

  return (
    <div>
      <div>{t("Milersättning kopplat till arbetet på")}:</div>
      {fields.map(fieldName => (
        <MileageAllowence key={fieldName} form={form} fieldName={fieldName} />
      ))}
    </div>
  );
}

export default compose()(MileageAllowences);
